import { render, staticRenderFns } from "./PrivateMessageForm.vue?vue&type=template&id=21c71a94&scoped=true"
import script from "./PrivateMessageForm.vue?vue&type=script&lang=js"
export * from "./PrivateMessageForm.vue?vue&type=script&lang=js"
import style0 from "./PrivateMessageForm.vue?vue&type=style&index=0&id=21c71a94&prod&lang=css"
import style1 from "./PrivateMessageForm.vue?vue&type=style&index=1&id=21c71a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c71a94",
  null
  
)

export default component.exports